
import React, { useEffect } from 'react';
import { BounceInDownButton } from '../../animation/bounceIn';
import { useNavigate } from 'react-router-dom';


const NotWhitelisted = () => {

    const navigate = useNavigate()

    useEffect(() => {
        if (sessionStorage.getItem("apayroucarayxczijiuhxvkdsp")) {
            navigate('/dashboard')
        }
    }, [])
    return (
        <section className="PageNotFoundSec">
            <div className="container">
                <div className="row align-items-center justify-content-center min-vh-100 py-4">

                    <div className="col-12">
                        <div className="PageNotFoundCnt">
                            <div className="my-5"><img src={require('../../assets/images/whitelist.png')} alt="whitelist" className="img-fluid" /></div>
                            <BounceInDownButton>
                                <h6>Your IP address is not whitelisted !!!</h6>
                            </BounceInDownButton>
                        </div>
                    </div>

                </div>
            </div>
        </section>
    )
}

export default NotWhitelisted;